import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faCode, faServer, faDatabase, faDownload } from '@fortawesome/free-solid-svg-icons';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const downloadCV = () => {
    const link = document.createElement('a');
    link.href = '/Anayo_Anyafulu_CV.pdf';
    link.download = 'Anayo_Anyafulu_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900">
      <div className="container-max-width section-padding text-center">
        <div className="animate-fade-in">
          {/* Profile Image Placeholder */}
          <div className="w-32 h-32 mx-auto mb-8 rounded-full bg-gradient-to-r from-primary-500 to-primary-600 flex items-center justify-center">
            <FontAwesomeIcon icon={faCode} className="text-4xl text-white" />
          </div>
          
          {/* Name and Title */}
          <h1 className="text-5xl md:text-6xl font-bold mb-4">
            <span className="gradient-text">Anayo Anyafulu</span>
          </h1>
          
          <h2 className="text-2xl md:text-3xl text-dark-300 mb-6 font-medium">
            Backend Engineer
          </h2>
          
          {/* Bio */}
          <p className="text-lg md:text-xl text-dark-400 max-w-3xl mx-auto mb-12 leading-relaxed">
            Hi, I'm Anayo Anyafulu, a Backend Engineer focused on building robust systems with Java, Rust, and AI-powered tools.
            I specialize in high-performance networking, distributed systems, and scalable cloud architectures.
          </p>
          
          {/* Tech Icons */}
          <div className="flex justify-center space-x-8 mb-12">
            <div className="flex items-center space-x-2 text-primary-400">
              <FontAwesomeIcon icon={faServer} className="text-2xl" />
              <span className="text-sm font-medium">Backend</span>
            </div>
            <div className="flex items-center space-x-2 text-primary-400">
              <FontAwesomeIcon icon={faDatabase} className="text-2xl" />
              <span className="text-sm font-medium">Database</span>
            </div>
            <div className="flex items-center space-x-2 text-primary-400">
              <FontAwesomeIcon icon={faCode} className="text-2xl" />
              <span className="text-sm font-medium">APIs</span>
            </div>
          </div>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => scrollToSection('projects')}
              className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300 hover:scale-105"
            >
              View My Work
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="border-2 border-primary-600 text-primary-400 hover:bg-primary-600 hover:text-white px-8 py-3 rounded-lg font-medium transition-all duration-300"
            >
              Get In Touch
            </button>
            <button 
              onClick={downloadCV}
              className="bg-dark-700 hover:bg-dark-600 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
            >
              <FontAwesomeIcon icon={faDownload} className="text-sm" />
              Download CV
            </button>
          </div>
          
          {/* Social Links */}
          <div className="flex justify-center space-x-6 mt-12">
            <a 
              href="https://github.com/Anayo-Anyafulu" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-dark-400 hover:text-primary-400 transition-colors duration-300"
              aria-label="GitHub Profile"
            >
              <FontAwesomeIcon icon={faGithub} className="text-2xl" />
            </a>
            <a 
              href="https://linkedin.com/in/anayoanyafulu" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-dark-400 hover:text-primary-400 transition-colors duration-300"
              aria-label="LinkedIn Profile"
            >
              <FontAwesomeIcon icon={faLinkedin} className="text-2xl" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
